import { Controller } from "@hotwired/stimulus"

const PHOTOS_PER_PAGE = 12

export default class extends Controller {
  static get targets() {
    return ["body"]
  }

  static get values() {
    return {
      memorialSlug: String,
      photoId: String,
      photoUrl: String
    }
  }

  connect() {
    this.page = 1
    if (this.photoIdValue) {
      this.renderSelected()
    } else {
      this.fetchPhotos(this.page)
    }
  }

  async fetchPhotos(page) {
    try {
      const response = await fetch(
        `/${this.memorialSlugValue}/photos.json?per=${PHOTOS_PER_PAGE}&page=${page}`,
        { headers: { Accept: "application/json" } }
      )
      if (!response.ok) throw new Error("Failed to load photos")

      const data = await response.json()
      this.page = data.page
      this.photos = data.photos
      this.totalPhotos = data.total_num_of_photos
      this.renderPicker()
    } catch (error) {
      this.photos = []
      this.totalPhotos = 0
      this.renderPicker()
    }
  }

  selectPhoto(event) {
    const id = event.currentTarget.dataset.photoId
    const url = event.currentTarget.dataset.photoUrl
    this.photoIdValue = id
    this.photoUrlValue = url
    this.renderSelected()
    this.dispatch("changed", {
      detail: { blockData: { photo_id: id, photo_url: url } },
      prefix: "homer-block"
    })
  }

  nextPage() {
    this.fetchPhotos(parseInt(this.page, 10) + 1)
  }

  previousPage() {
    this.fetchPhotos(parseInt(this.page, 10) - 1)
  }

  renderSelected() {
    this.bodyTarget.innerHTML = `
      <div class="homer-viewer__block">
        <div class="photo-from-gallery-block-viewer">
          <img src="${this.escapeHtml(this.photoUrlValue)}">
        </div>
      </div>
    `
  }

  renderPicker() {
    const emptyState =
      this.totalPhotos === 0 ? `<p class="text-center">There are no photos yet.</p>` : ""

    const photosHtml = (this.photos || [])
      .map(
        (photo) => `
          <div class="pickable-photo" style="background-image: url('${this.escapeHtml(photo.url)}')"
               data-action="click->homer-photo-from-gallery-block#selectPhoto"
               data-photo-id="${photo.id}" data-photo-url="${this.escapeHtml(photo.url)}"></div>
        `
      )
      .join("")

    const nextHtml =
      this.totalPhotos > this.page * PHOTOS_PER_PAGE
        ? `<div class="pagination next" data-action="click->homer-photo-from-gallery-block#nextPage">Next Page</div>`
        : ""
    const prevHtml =
      this.page > 1
        ? `<div class="pagination prev" data-action="click->homer-photo-from-gallery-block#previousPage">Previous Page</div>`
        : ""

    this.bodyTarget.innerHTML = `
      <div class="photo-from-gallery-block-content">
        ${emptyState}
        ${photosHtml}
        ${nextHtml}
        ${prevHtml}
      </div>
    `
  }

  escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;")
  }
}
